import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import Popover2 from "./popover-2";
import Layout from "../layout/layout";
import Bar from "../layout/bar";
import FilterPopoverDropdown from "./filter-popover-dropdown";
import PlainButton from "../elements/plain-button";
import Button from "../elements/button";
import ButtonTooltip from "./button-tooltip";
import Checkbox from "../forms/checkbox";
import Icon from "../elements/icon";

const FilterPopover = ({
  className,
  config,
  activeFilters,
  onFilterChange,
  buttonText = "More Filters",
  buttonType = "toggle",
  onApply,
  onClear,
}) => {
  const onTempCheckboxFilterChange = (isChecked, filterKey, section) => {
    const oldSection = activeFilters[section] || [];

    let newSection = isChecked ? oldSection.concat(filterKey) : _.without(oldSection, filterKey);

    const newFilters = { ...activeFilters, [section]: newSection };

    onFilterChange(newFilters);
  };

  const onTempDropdownFilterChange = (section, options) => {
    const values = _.pluck(options, "value");
    const newFilters = { ...activeFilters, [section]: values };

    onFilterChange(newFilters);
  };

  const numFilters = _.reduce(
    activeFilters,
    (memo, num) => {
      return memo + num.length;
    },
    0
  );

  return (
    <Popover2
      className={className}
      caretSize={0}
      onClose={onApply}
      trigger={
        <Button type={buttonType}>
          {buttonText}
          {numFilters ? ` (${numFilters})` : ""}
        </Button>
      }
    >
      {({ closePopover }) => (
        <Layout
          footerBorder={false}
          footer={
            <Bar
              padding="20px 30px"
              left={
                <PlainButton
                  onClick={() => {
                    closePopover();
                    onClear();
                  }}
                >
                  Clear
                </PlainButton>
              }
              right={
                <PlainButton
                  style={{ color: "#19a4df" }}
                  onClick={() => {
                    closePopover();
                    onApply();
                  }}
                >
                  Apply
                </PlainButton>
              }
            />
          }
        >
          {_.map(config, (values, section) => (
            <div className="et--filter-section" key={values.title}>
              {/* title */}
              <div className="et--filter-group-name">
                <div className="et--filter-group-name-title">
                  <strong>{values.title}</strong>
                  <span className="et--filter-group-help">
                    {values.help_tip ? (
                      <ButtonTooltip trigger={<Icon icon="help" style={{ color: "#aec6cc" }} />}>
                        {values.help_tip}
                      </ButtonTooltip>
                    ) : null}
                  </span>
                </div>
              </div>

              <div className="et--filter-group-options">
                {/* checkboxes */}
                {(!values.type || values.type === "checkbox") &&
                  _.map(values.options, ({ name, key, icon, color }) => {
                    const sectionKeys = activeFilters[section] || [];
                    return (
                      <div className="et--filter-option" key={key}>
                        {name !== "spacer" ? (
                          <Checkbox
                            checked={_.contains(sectionKeys, key)}
                            onChange={isChecked => onTempCheckboxFilterChange(isChecked, key, section)}
                            label={name}
                          >
                            {name}
                            {icon ? <Icon icon={icon} className="et--filter-option-icon" style={{ color }} /> : null}
                          </Checkbox>
                        ) : null}
                      </div>
                    );
                  })}

                {/* dropdowns */}
                {values.type === "dropdown" && (
                  <FilterPopoverDropdown
                    filterKey={section}
                    options={values.options}
                    values={activeFilters[section]}
                    onChange={onTempDropdownFilterChange}
                    multiple={values.multiple}
                    searchable={values.searchable}
                    allowChangeAll={values.allowChangeAll}
                    allowUnselectAll={values.allowUnselectAll}
                    width={values.width}
                  />
                )}
              </div>
            </div>
          ))}
        </Layout>
      )}
    </Popover2>
  );
};

FilterPopover.propTypes = {
  className: PropTypes.string,
  config: PropTypes.object,
  activeFilters: PropTypes.object,
  onFilterChange: PropTypes.func,
  buttonText: PropTypes.string,
  buttonType: PropTypes.string,
  onApply: PropTypes.func,
  onClear: PropTypes.func,
};

export default FilterPopover;
